import { Link } from 'react-router-dom';

export default function Home() {
  return (
    // This is the template home page, please edit from this page
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <div className="relative z-10">
        <h1 className="font-heading text-xl md:text-2xl font-semibold mt-6 text-foreground-950">This is homepage, but there is no content yet</h1>
        <p className="mt-4 text-lg md:text-xl text-foreground-500">Tell me more about homepage, so I can generate it</p>
        <Link
          to="/about"
          className="mt-6 inline-flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-information-line" />
          View the About page
        </Link>
      </div>
    </div>
  );
}